/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JourneyConfigurationPageQuery$parameters.ts';
import type { JourneyConfigurationPageQuery as JourneyConfigurationPageQueryType } from './__generated__/JourneyConfigurationPageQuery.graphql.ts';

type Queries = {
	jiraJourneyConfiguration: JourneyConfigurationPageQueryType;
};

type JourneyConfigEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const journeyConfigEntryPoint: EntryPoint<
	JourneyConfigEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<JourneyConfigEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-journey-configuration-edit" */ './JourneyConfigurationPage.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		return {
			queries: {
				jiraJourneyConfiguration: {
					options: {
						fetchPolicy: 'network-only' as const,
					},
					parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						cloudIdAsString: tenantContext.cloudId,
						projectKey: context.match.params.projectKey || '',
						journeyId: context.match.params.journeyId ?? '',
						isEditing: context.match.path?.includes('journeys/:journeyId/edit'),
						includeRovoServiceAgent: fg('enable-jsm-rovo-service-hr-agent'),
					},
				},
			},
			entryPoints: {},
			extraProps: {},
		};
	},
});
